import React, { useEffect, useState } from 'react';
import { Card, Button, Modal } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';

import CreateCustomerModal from '../../Shared/Modals/Create/CreateCustomerModal';
import EditCustomerModal from '../../Shared/Modals/Edit/EditCustomerModal';
import PageTable from '../../Shared/PageTable/PageTable';
import SMSSender from '../../Shared/SMSSender/SMSSender';
import EmailSender from '../../Shared/EmailSender/EmailSender';

function Customers(props) {

    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [updateTable, setUpdateTable] = useState(0);
    const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
    const [showEditCustomerModal, setShowEditCustomerModal] = useState(false);
    const [showDeleteCustomerModal, setShowDeleteCustomerModal] = useState(false);
    const [deleteCustomerId, setDeleteCustomerId] = useState();
    const [editCustomerId, setEditCustomerId] = useState();

    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [showSMSSendModal, setShowSMSSendModal,] = useState(false);
    const [showEmailSendModal, setShowEmailSendModal,] = useState(false);

    const handleShowCreateCustomerModal = () => { setShowCreateCustomerModal(true); };
    const handleShowSMSSendModal = () => { setShowSMSSendModal(true); };
    const handleShowEmailSendModal = () => { setShowEmailSendModal(true); };

    const handleCloseDeleteCustomerModal = () => {setShowDeleteCustomerModal(false);}

    const handleShowEditCustomerModal = (dataLine) => { 
        setEditCustomerId(dataLine["_id"]);
        setShowEditCustomerModal(true); 
    };
    const handleShowDeleteCustomerModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation(); 
        setDeleteCustomerId(dataLine["_id"]);
        setShowDeleteCustomerModal(true); 
    };

    const handleSendSMS = (selectedIds) => {
        setSelectedItems(selectedIds);
        handleShowSMSSendModal();
    }

    const handleSendEmail = (selectedIds) => {
        setSelectedItems(selectedIds);
        handleShowEmailSendModal();
    }

    function handleDeleteCustomer(){
        axios.delete(
            "/api/customers",
            {
                customerid: deleteCustomerId,
            },
            {
                headers: { 'x-access-token': auth.user["token"] } 
            }
        ).then(res=> {
            handleCloseDeleteCustomerModal();
            setUpdateTable(updateTable + 1);
        });
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
    }, []);

    return (
        <div className="maincontent">
            <div className="customers-container">
                <Card>
                    <Card.Body>
                        <h4 className="header-title">{t("customers.title")}</h4>
                        {auth.user["userdata"]["role"][0] === "Admin" &&
                            <Button onClick={handleShowCreateCustomerModal}>{t("customers.new")}</Button>
                        }
                        <br />
                        <hr />

                        <PageTable
                            dataUrl={"/api/customers/getAllPaged"}
                            checkAllUrl="/api/customers/getAllPaged/checkAll"
                            allDataUrl="/api/customers"
                            selectedFunctions={[
                                { label: t("customers.send_SMS"), func: (selectedItems) => handleSendSMS(selectedItems) },
                                { label: t("customers.send_email"), func: (selectedItems) => handleSendEmail(selectedItems) },
                            ]}
                            options={{
                                showFields: [
                                    { label: t("customers.organization"), field: "organizationName", override: (dataLine)=>{ 
                                        if(dataLine.companyRegistrationId != undefined && dataLine.companyRegistrationId != "" ){
                                            if(
                                                dataLine.apArNo == "" ||
                                                dataLine.organizationName == "" ||
                                                dataLine.companyRegistrationId == "" || 
                                                dataLine.firstname == "" || 
                                                dataLine.lastname == "" || 
                                                dataLine.address == "" || 
                                                dataLine.email == "" || 
                                                dataLine.phone == "" || 
                                                dataLine.relAttrId == "" ||
                                                dataLine.apArNo == undefined ||
                                                dataLine.organizationName == undefined ||
                                                dataLine.companyRegistrationId == undefined || 
                                                dataLine.firstname == undefined || 
                                                dataLine.lastname == undefined || 
                                                dataLine.address == undefined || 
                                                dataLine.email == undefined || 
                                                dataLine.phone == undefined || 
                                                dataLine.relAttrId == undefined
                                            ){
                                                return <span><i className="dripicons-warning" style={{color: "red"}}/>  {dataLine.organizationName}</span> 
                                               
                                            }else{
                                                return dataLine.organizationName; 
                                            }
                                        }else{
                                            if(
                                                dataLine.firstname == "" || 
                                                dataLine.lastname == "" || 
                                                dataLine.address == "" || 
                                                dataLine.email == "" || 
                                                dataLine.phone == "" || 
                                                dataLine.firstname == undefined || 
                                                dataLine.lastname == undefined || 
                                                dataLine.address == undefined || 
                                                dataLine.email == undefined || 
                                                dataLine.phone == undefined  
                                               
                                            ){
                                                return <span><i className="dripicons-warning" style={{color: "red"}}/>{dataLine.organizationName}</span> 
                                               
                                            }else{
                                                return dataLine.organizationName; 
                                            }
                                        }
                                    }},
                                    { label: t("customers.firstname"), field: "firstname" },
                                    { label: t("customers.lastname"), field: "lastname" },
                                    { label: t("customers.email"), field: "email" },
                                    { label: t("customers.phone"), field: "phone" },
                                    
                                    ]
                            }}
                            dataAfter={(dataLine) => auth.user["userdata"]["role"] == "Admin" ? 
                                <div><Button onClick={(evt) => handleShowDeleteCustomerModal(dataLine, evt)}>{t("customers.delete")}</Button></div>
                            : null }
                            onLineClick={handleShowEditCustomerModal}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            updateTable={updateTable}
                            hover={true}
                        />
                    </Card.Body>
                </Card>

                <CreateCustomerModal
                    show={showCreateCustomerModal}
                    onCancel={() => setShowCreateCustomerModal(false)}
                    onHide={() => setShowCreateCustomerModal(false)}
                    onSaveNew={() => {
                        setShowCreateCustomerModal(false); 
                        setUpdateTable(updateTable + 1);
                    }}
                ></CreateCustomerModal>

                <EditCustomerModal
                    show={showEditCustomerModal}
                    customerId={editCustomerId}
                    onCancel={() => setShowEditCustomerModal(false)}
                    onHide={() => setShowEditCustomerModal(false)}
                    onSave={() => {
                        setShowEditCustomerModal(false);
                        setUpdateTable(updateTable + 1);
                    }}
                ></EditCustomerModal>

                <Modal show={showDeleteCustomerModal} onHide={handleCloseDeleteCustomerModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("customers.deleteCustomer")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("customers.delete_info")}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleCloseDeleteCustomerModal}>{t("customers.cancel")}</Button>
                        <Button onClick={handleDeleteCustomer}>{t("customers.delete")}</Button>
                    </Modal.Footer>
                </Modal>

                <SMSSender
                    show={showSMSSendModal}
                    onHide={() => setShowSMSSendModal(false)}
                    onCancel={() => setShowSMSSendModal(false)}
                    recipients={selectedItems.map(i => { return { number: i.phone, name: i.lastname + ", " + i.firstname } })}
                ></SMSSender>

                <EmailSender
                    show={showEmailSendModal}
                    onHide={() => setShowEmailSendModal(false)}
                    onCancel={() => setShowEmailSendModal(false)}
                    recipients={selectedItems.map(i => { return { email: i.email, name: i.lastname + ", " + i.firstname } })}
                ></EmailSender>
            </div>
        </div>
    )
}


export default Customers;